module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7jbDmN/media/FC-9781638295440.jpg?1693228932273",
      "alt": "This image is the cover for the book A Taste of Freedom"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Taste of Freedom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Doug Samuels is a highly respected but emotionally challenged ex-cop turned private investigator, who is reeling from a heartbreakingly painful loss. Working out of a small office in the St. Louis neighbourhood called Central West End, and with the assistance of his best friend’s wife, he receives little warning of his destiny.")]), _c('p', [_vm._v("Wittingly chosen for the task, Doug is hired by the spouse of a successful investment banker. The alarmingly sexy blond suspects the man she married of cheating and asks Doug to verify her suspicions. His pretty client entices and manipulates Doug’s vulnerabilities as a second case, involving an ex-pimp turned NFL running back, lures Doug back and forth across the country, forcing him to dodge and deflect warranted scrutiny from the FBI.")]), _c('p', [_vm._v("Accepting each case with the best of intentions, Doug’s professional ethics, and high moral standards are continuously challenged as he’s pulled deeper and deeper into a world of deception, lies, sex, and murder. Doug’s good nature paired with his inability to say no changes his life forever.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Kevin Reed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Michael Kevin Reed was born and raised in St. Louis, Missouri. Graduated from Lindenwood and Capella Universities, his passion for a great story and his fascination with the human condition led him to pursue writing and the creation of his first novel, "), _c('em', [_vm._v("A Taste of Freedom")]), _vm._v(".")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0